import http from '../../../utils/fetch';
export default {
    page(query) {
        return http({
            url: '/api/swyl/v1/demo/bscLoud/selectPage',
            method: 'post',
            params: query
        });
    },
    selectPage(query) {
        return http({
            url: '/api/swyl/v1/demo/loudXin/selectPage',
            method: 'post',
            params: query
        });
    },
    // showProPage() {
    //     return http({
    //         url: '/api/swyl/v1/demo/bscLoud/showProPage',
    //         method: 'post',
    //     });
    // },
    selectReportPage(query) {
        return http({
            url: '/api/swyl/v1/demo/viewProductDay/selectPage',
            method: 'post',
            params: query
        });
    },
    // selectProPage(result) {
    //     return http({
    //         url: '/api/swyl/v1/demo/bscLoud/selectProPage',
    //         method: 'post',
    //         params: result
    //     });
    // },
    showLoud() {
        return http({
            url: '/api/swyl/v1/demo/bscLoud/showLoud',
            method: 'post',
        });
    },
    showHistory(obj) {
        return http({
            url: '/api/swyl/v1/demo/loudChangeMsg/showMsgPage',
            method: 'post',
            params: obj
        });
    },
    saveTo(obj) {
        return http.post('/api/swyl/v1/demo/bscLoud/saveUpdate',obj);
    },
    saveUpdate(query) {
        return http.post('/api/swyl/v1/demo/loudXin/saveUpdate',query);
    },
    subTo(obj) {
        return http.post('/api/swyl/v1/demo/bscLoud/subData',obj);
    },
    subData(obj) {
        return http.post('/api/swyl/v1/demo/loudXin/subData',obj);
    },
    deleteRow(obj) {
        return http.post('/api/swyl/v1/demo/bscLoud/deleteRow',obj);
    },
    deleteData(obj) {
        return http.post('/api/swyl/v1/demo/loudXin/deleteRow',obj);
    },
    //点击查看区域链群数据
    selectAreaGroupPage(query) {
        return http({
            url: '/api/swyl/v1/demo/viewArea/selectAreaGroupPage',
            method: 'post',
            params: query
        });
    },
    //点击查看区域交互数据
    selectAreaMutualPage(query) {
        return http({
            url: '/api/swyl/v1/demo/viewArea/selectAreaMutualPage',
            method: 'post',
            params: query
        });
    },
    //点击查看链群交互数据
    selectGroupMutualPage(query) {
        return http({
            url: '/api/swyl/v1/demo/loudProduct/selectGroupMutualPage',
            method: 'post',
            params: query
        });
    },
    showAdd(query) {
        return http({
            url: '/api/swyl/v1/demo/viewArea/showAdd',
            method: 'post',
            params: query
        });
    },
    showList(query) {
        return http({
            url: '/api/swyl/v1/demo/viewArea/showList',
            method: 'post',
            params: query
        });
    },
    showQuyu(query) {
        return http({
            url: '/api/swyl/v1/demo/viewArea/showQuyu',
            method: 'post',
            params: query
        });
    },
    showType() {
        return http({
            url: '/api/swyl/v1/demo/viewArea/showAllType',
            method: 'post',
        });
    },
    showJD() {
        return http({
            url: '/api/swyl/v1/demo/viewArea/showJD',
            method: 'post',
        });
    },
    showAllJD() {
        return http({
            url: '/api/swyl/v1/demo/viewArea/showAllJD',
            method: 'post',
        });
    },
    newSaveAndUpdateResource(query) {
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/newSaveAndUpdateResource',
            method: 'post',
            data: query
        });
    },
    closeStep(query) {
        return http({
            url: '/api/swyl/v1/loudnew/loudMain/closeStep',
            method: 'post',
            data: query
        });
    },
}